import * as React from "react";
import { base_url } from "../../../../Constants";
import httpService from 'services/httpService.js';
// Components
// import NavBar from "Screens_old/Layout/Common/Components/NavBar";
// import Footer from "Screens_old/Layout/Common/Components/Footer";
import { Row, Col, Alert, Tab, Form, Button } from "react-bootstrap";
import displayGlobalMessage from 'Utils/DisplayGlobalMessage';
import log from "loglevel";

// Components
export default class ForgotPassword extends React.Component {

    state = {
        loginUsername: "",
        loginEmail: ""
    };

    handleChange = (e) => {
        e.preventDefault();
        this.setState({ ...this.state, [e.target.name]: e.target.value });
    }

    handleLogin = async (e) => {
        e.preventDefault();
        var jsonBody = {};
        if (!this.state.loginUsername && !this.state.loginEmail) {
            displayGlobalMessage("PLease enter either username or email address", "error"); return;
        }
        else if (!this.state.loginUsername) {
            jsonBody = { "email": this.state.loginEmail };
        }
        else if (!this.state.loginEmail) {
            jsonBody = { "username": this.state.loginUsername };
        }
        else {
            displayGlobalMessage("Enter only one of username or email. Leave the other as blank", "error");
            return;
        }
        try {
            const response = await httpService.post(
                base_url + `/accounts/forgotpasswordapi/`
                , jsonBody
            );
            log.log(response);
            if (response.status === 200) {
                log.log(response.data.message);
                this.setState({
                    loginUsername: "",
                    loginEmail: ""
                });
                displayGlobalMessage(response.data.message, "success");
            }

        } catch (err) {
            log.log(err);
            if (err.message==="Request failed with status code 404")
                // alert("Username/Email does not exist");
                displayGlobalMessage("Username/Email does not exist", "error");
            else alert(err.message);
        }
    }



    render() {
        const { loginUsername, loginEmail } = this.state;
        return (
            <div>
                    {/* <img src={'/public/images/landing_page.jpg'} className="w-100" style={{ maxHeight: 500 }} /> */}
                    <Row>
                        <Col>
                            <Alert
                                className={this.props?.msg === null ? "d-none" : ""}
                                variant={"success"}
                            >
                                {this.props?.msg}
                            </Alert>
                            <Alert
                                className={this.props?.error === null ? "d-none" : ""}
                                variant={"danger"}
                            >
                                {this.props?.error !== null && this.props?.error?.toString()}
                            </Alert>
                            <Row className="justify-content-md-center">
                                <Col sm={12}>
                                    <h4 eventKey="signin" className="w-100 text-center">

                                    </h4>
                                </Col>
                                <Col sm={12}>
                                    <Tab.Content>
                                        <p style={{ textAlign: 'center', textDecoration: 'underline' }}>Change/Forgot Password?</p>
                                        <Form className="d-flex flex-column justify-content-center align-items-center">
                                            <Form.Group controlId="formBasicEmail">
                                                <Form.Control
                                                    value={loginUsername}
                                                    name={"loginUsername"}
                                                    onChange={this.handleChange}
                                                    type="text"
                                                    placeholder="Username"
                                                    className="my-3"
                                                />
                                            </Form.Group>

                                            <div style={{ textAlign: 'center' }} className="w-100 d-flex justify-content-center">
                                                <hr className="w-100" />
                                                <div style={{ transform: 'translate(0, 20%)' }}>OR</div>
                                                <hr className="w-100" />
                                            </div>


                                            <Form.Group controlId="formBasicEmail">
                                                <Form.Control
                                                    value={loginEmail}
                                                    name={"loginEmail"}
                                                    onChange={this.handleChange}
                                                    type="email"
                                                    placeholder="Email"
                                                    className="my-3"
                                                />
                                            </Form.Group>
                                            <Button
                                                variant="primary"
                                                type="submit"
                                                className="btn btn-block btn-lg my-3"
                                                onClick={(e) => this.handleLogin(e)}
                                            >
                                                Submit
                                            </Button>
                                            <div className="d-flex flex-column text-center">
                                                {/* <a href="/login" className="my-3">
                                                    Login
                                                </a> */}
                                                <a href='javascript:void(0)' onClick={()=>this.props?.handlerLogin()} className="my-3 modalDialog2">
                                                    Login
                                                </a>
                                            </div>
                                        </Form>
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
            </div>
        );
    }
}
